<template lang="html">
    <div>
        Edit Album
        <div v-if="isLoadingAlbum == false">

          <v-container>
            <v-flex xs12>
              <language-selector v-if="album.id" :albumId="mainAlbumId"/>
            </v-flex>
          </v-container>

          <album-form  v-model="album" />

          <!-- Buttons -->
          <v-layout justify-space-between>

            <div>
              <v-btn color="success" large @click="clickSave()">Guardar</v-btn>
              <v-btn color="" large @click="clickCancel()">Cancelar</v-btn>
            </div>

            <v-btn color="error" large @click="clickDelete()">Apagar</v-btn>
          </v-layout>

          <v-dialog
            v-model="showDeleteDialog"
            max-width="290"
          >
            <v-card>
              <v-card-title class="headline">Apagar album "{{album.title}}?"</v-card-title>

              <v-card-text>
                Atenção: Esta ação não é reversível.
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="closeDeleteDialog"
                >
                  Cancelar
                </v-btn>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="confirmDelete()"
                >
                  Continuar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <div v-else>
          A Carregar
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import languageSelector from '@/components/Album/languageSelector'
import albumForm from '@/components/Album/albumForm'
export default {
  created: function () {
    //if ew dont have a albumId on route params route to albumList
    if(!this.$route.params.albumId){
      this.$router.push({ name: 'AlbumList' })
    } else {
      this.isLoadingAlbum = true
      this.downloadAlbum({
        id: this.$route.params.albumId,
        language: this.$route.params.language? this.$route.params.language : "pt"
      }).then(response => {
        this.album = response.data
        this.isLoadingAlbum = false
      })
    }
  },
  data: function () {
    return {
      isLoadingAlbum: false,
      showDeleteDialog: false,
      // album: {
      //   title: null,
      //   author: null,
      //   release_date: null,
      //   serial: null,
      //   spotify_widget: null,
      //   cover_image: null,
      //   descriptions:[],
      //   platforms:[],
      // },
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedAlbum',
    ]),
    mainAlbumId: function () {
      return this.album.album_id? Number(this.album.album_id) : Number(this.album.id)
    },
    album: {
      get: function () {
        return this.getSelectedAlbum
      },
      set: function(newVal) {
        this.updateSelectedAlbum(newVal)
      }
    }
  },
  methods: {
    ...mapActions([
      'downloadAlbum',
      'saveAlbum',
      'deleteAlbum',
      'updateSelectedAlbum'
    ]),
    clickSave: function () {
      this.saveAlbum({
        album:this.album,
        language: this.$route.params.language
      }).then(() => {
        this.$router.push({ name: 'AlbumList' })
      })
    },
    clickCancel: function () {
      this.$router.push({ name: 'AlbumList' })
    },
    clickDelete: function () {
      this.showDeleteDialog = true
    },
    closeDeleteDialog: function () {
      this.showDeleteDialog = false
    },
    confirmDelete: function () {
      this.deleteAlbum(this.mainAlbumId).then(() =>{
        this.closeDeleteDialog()
        this.$router.push({ name: 'AlbumList' })
      })
    }
  },
  components:{
    languageSelector,
    albumForm
  }
}
</script>

<style lang="css" scoped>
</style>
